import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import ExchangeButton from 'src/pages/main/shop/components/ShopHeartTab/ExchangeButton'
import ShopExchangeConfirmModal from 'src/pages/main/shop/components/ShopHeartTab/ShopExchangeConfirmModal'
import { useShopContext } from 'src/pages/main/shop/contexts/ShopContext'
import ShopExplanatoryModal from 'src/pages/main/shop/components/ShopDiamondTab/ShopExplanatoryModal'

import DiamondRed from 'src/assets/img/common/diamond-red.png'
import Life from 'src/assets/img/common/life.png'
import SpecialItem from 'src/assets/img/common/special_item.png'
import LightPink from 'src/assets/img/shop/light_pink_arrow.png'
import MagnifyingGlassButton from 'src/assets/img/shop/magnifying_glass.png'

const ContentBox = styled.div.attrs({
  className:
    'relative flex flex-col items-center justify-center w-16 p-1.5 my-2 border border-light-pinkish rounded-md text-sm text-bubblegum-pink font-bold font-Inter'
})``

const ShopExchangeHeart = ({ heartExchangeConfig }) => {
  const { setModalContent, setSelectedHeartExchange } = useShopContext()

  const numberOfRedDiamonds = parseInt(heartExchangeConfig?.number_of_red_diamonds)
  const numberOfHeartsExchanged = parseInt(heartExchangeConfig?.number_of_hearts_exchanged)

  const isExchangeSpecialItem = heartExchangeConfig.name === '夢のランプ'

  const onSelect = () => {
    setSelectedHeartExchange(heartExchangeConfig)
    setModalContent(<ShopExchangeConfirmModal />)
  }

  const handleShowDetail = () => {
    setModalContent(
      <ShopExplanatoryModal
        shopDetails={{
          first_name: '夢の時間をお届け！',
          explanatory_text:
            'もっと大人な非日常は彼と貴女だけの秘密の時間♥\n夢のランプは所持するだけで効果を発揮しますので、REALTALKでの使用はくれぐれも行わないようお願いいたします。また夢のランプは、本日22:30以降に自動削除されます',
          number_of_red_diamonds: heartExchangeConfig?.number_of_red_diamonds || 1,
          id: heartExchangeConfig?.id
        }}
      />
    )
  }

  return (
    <li className="flex items-center justify-between w-full h-full pl-2 pr-6">
      <div className="flex gap-2">
        <div className="flex items-center">
          <ContentBox>
            <img src={DiamondRed} className="w-9" />
            <span>x {numberOfRedDiamonds}</span>
          </ContentBox>
          <img src={LightPink} className="w-4 h-4" />
        </div>
        <ContentBox>
          {isExchangeSpecialItem ? (
            <img src={SpecialItem} className="w-12" />
          ) : (
            <img src={Life} className="w-9" />
          )}

          {!isExchangeSpecialItem && <span>x {numberOfHeartsExchanged}</span>}

          {isExchangeSpecialItem && (
            <button
              className="absolute -bottom-2 -right-2 z-10"
              type="button"
              onClick={handleShowDetail}
            >
              <img src={MagnifyingGlassButton} className="w-5" />
            </button>
          )}
        </ContentBox>
      </div>

      <ExchangeButton onClick={onSelect} />
    </li>
  )
}

ShopExchangeHeart.propTypes = {
  heartExchangeConfig: PropTypes.object.isRequired
}

export default ShopExchangeHeart
